// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".writing .cursor{content:\"\";width:7px;height:20px;display:inline-block;vertical-align:sub;background-color:#000;-webkit-animation:blink 2s infinite;animation:blink 2s infinite}@-webkit-keyframes blink{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes blink{0%,50%,to{opacity:1}25%,75%{opacity:0}}", ""]);
// Exports
module.exports = exports;
